import { render, staticRenderFns } from "./actionTemplatesForm.vue?vue&type=template&id=786ca5a3&scoped=true"
import script from "./actionTemplatesForm.vue?vue&type=script&lang=js"
export * from "./actionTemplatesForm.vue?vue&type=script&lang=js"
import style0 from "./actionTemplatesForm.vue?vue&type=style&index=0&id=786ca5a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786ca5a3",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardActions,QSpace,QBtn,QCardSection,QForm,QInput});
